import { BaseModel } from '../email-template/base-model.interface';
import BlockModel from '../email-template/block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';
import { EventInitVariables } from '../email-template/event.interface';

export interface WebPushModel extends BaseModel {
  variables?: { [key: string]: string } | WebPushVariables;
}

export interface WebPushVariables {
  WebPushCopy: string;
  WebPushCta: string;
  WebPushImage: string;
  WebPushLink: string;
  WebPushTitle: string;
}

export class WebPushInitVariables implements WebPushVariables {
  WebPushCopy = '';
  WebPushCta = '';
  WebPushImage = '';
  WebPushLink = '';
  WebPushTitle = '';
}

export class WebPushInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new WebPushInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
